var _path, _path2, _g, _path3, _path4, _path5, _g2, _path6, _g3, _path7, _g4, _path8, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDalocalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 42,
    viewBox: "0 0 30 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_919_14812)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6348 42C14.6348 42 14.6733 41.9619 14.7503 41.9239C16.2523 41.01 22.26 34.7652 23.993 33.0898C30.5013 26.7308 28.8838 18.0871 23.6079 13.3654C23.1072 12.8323 22.4525 12.3373 21.6823 11.9184C19.6412 10.6619 17.215 9.9003 14.5963 9.93838C11.9776 9.9003 9.55137 10.6619 7.51029 11.9565C6.77859 12.3754 6.08539 12.8704 5.58475 13.4035C0.308755 18.0871 -1.27019 26.7308 5.19964 33.0898C6.93263 34.8033 12.9403 41.01 14.4423 41.9239C14.4808 41.9619 14.5193 42 14.5578 42C14.5963 42 14.5963 42 14.6348 42Z",
    fill: "#F48121"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_919_14812",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 10,
    width: 26,
    height: 31
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0199 40.9717C15.0199 40.9717 15.0584 40.9337 15.0969 40.8956C16.5603 40.0579 22.2214 34.1558 23.8774 32.5565C30.0006 26.5783 28.5372 18.3915 23.5308 13.9364C23.0686 13.4414 22.414 12.9844 21.7208 12.5656C19.7952 11.3471 17.4846 10.6617 15.0199 10.6997C12.5167 10.6617 10.2445 11.3852 8.28045 12.5656C7.58726 12.9844 6.93257 13.4414 6.47044 13.9364C1.50253 18.3915 0.000608683 26.5783 6.12384 32.5565C7.77981 34.1558 13.4409 40.0579 14.8658 40.8956C14.9043 40.9337 14.9428 40.9717 14.9428 40.9717C14.9814 40.9717 14.9814 40.9717 15.0199 40.9717Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_919_14812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 10.6616H0V40.9717H30V10.6616Z",
    fill: "url(#paint0_linear_919_14812)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0183 17.478C18.3688 17.478 21.103 20.1816 21.103 23.4943C21.103 26.8071 18.3688 29.5107 15.0183 29.5107C11.6679 29.5107 8.93359 26.8071 8.93359 23.4943C8.93359 20.1816 11.6294 17.478 15.0183 17.478Z",
    fill: "#F48121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0187 18.3535C17.9071 18.3535 20.2562 20.6763 20.2562 23.5321C20.2562 26.388 17.9071 28.6726 15.0187 28.6726C12.1304 28.6726 9.78125 26.3499 9.78125 23.494C9.78125 20.6382 12.1304 18.3535 15.0187 18.3535Z",
    fill: "#00266B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_919_14812",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 9,
    width: 6,
    height: 7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9869 9.63361L21.0279 10.814C21.182 10.9283 21.259 11.1187 21.1435 11.309L19.0254 14.9645C18.9098 15.1168 18.7173 15.193 18.5247 15.0788L16.4837 13.8983C16.3296 13.7841 16.2526 13.5937 16.3681 13.4033L18.4862 9.74785C18.6018 9.59554 18.8328 9.51938 18.9869 9.63361Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_919_14812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2994 9.51953H16.293V15.1551H21.2994V9.51953Z",
    fill: "url(#paint1_linear_919_14812)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_919_14812",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 8,
    width: 6,
    height: 6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0339 8.68192L26.6899 10.167C26.8439 10.3193 26.8824 10.5858 26.7284 10.7762L23.9556 13.8224C23.8016 13.9748 23.532 14.0128 23.3394 13.8605L21.6834 12.3755C21.5294 12.2232 21.4909 11.9566 21.6449 11.7662L24.4177 8.72C24.5718 8.56769 24.8413 8.52961 25.0339 8.68192Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_919_14812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8837 8.52979H21.4922V13.9749H26.8837V8.52979Z",
    fill: "url(#paint2_linear_919_14812)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_919_14812",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 0,
    width: 6,
    height: 6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5642 0H25.0315C25.2626 0 25.4166 0.19039 25.4166 0.418858V4.8359C25.4166 5.06437 25.2241 5.25476 24.993 5.25476H20.5642C20.3332 5.25476 20.1406 5.06437 20.1406 4.8359V0.418858C20.1791 0.19039 20.3332 0 20.5642 0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_919_14812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4557 0H20.1797V5.21668H25.4557V0Z",
    fill: "url(#paint3_linear_919_14812)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_919_14812",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 3,
    width: 6,
    height: 7
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1107 5.10255L27.8449 3.99829C28.0375 3.92213 28.2686 3.99829 28.3456 4.22675L29.8475 7.92032C29.9245 8.11071 29.8475 8.33917 29.6164 8.41533L26.8822 9.51959C26.6896 9.59575 26.4585 9.51959 26.3815 9.29112L24.8796 5.59756C24.8026 5.40717 24.9181 5.21678 25.1107 5.10255Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_919_14812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9227 3.96045H24.8008V9.59599H29.9227V3.96045Z",
    fill: "url(#paint4_linear_919_14812)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_919_14812",
    x1: 2.10957,
    y1: 25.8292,
    x2: 27.905,
    y2: 25.8292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D53E0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF7E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_919_14812",
    x1: 16.2068,
    y1: 12.3496,
    x2: 21.3741,
    y2: 12.3497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3E63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_919_14812",
    x1: 21.3468,
    y1: 11.2715,
    x2: 26.9936,
    y2: 11.2714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6210BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B2E71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_919_14812",
    x1: 20.1587,
    y1: 2.60113,
    x2: 25.4246,
    y2: 2.60113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0A00C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_919_14812",
    x1: 24.7406,
    y1: 6.78058,
    x2: 29.9864,
    y2: 6.78058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D5D59"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_919_14812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDalocalIcon);
export default __webpack_public_path__ + "static/media/dalocal-icon.cbfeff413f27ecd64a64b0b5eb271aeb.svg";
export { ForwardRef as ReactComponent };